<div class="ui-component" [ngClass]="component | componentClasses">
  <div class="ui-component__content">
    <div class="ui-component__content-wrapper">

      <ng-container *ngIf="component.componentConfig.selector != 'ui-post--pdf-section' &&
                           component.componentConfig.selector != 'ui-post--catalog-link'">
        <!-- <p [innerHtml]="parent?.shortDescription | trustHtml"></p> -->
        <div class="c-inner-post">
          <div class="e-title e-title__with-divider" *ngIf="component?.content?.title">
            <h2 [innerHTML]="component?.content?.title | trustHtml"></h2>
            <hr class="hr hr--heavy hr--brand hr--title mb-2">
          </div>
          <picture class="c-inner-post__image" *ngIf="component.content?.image">
            <img src="{{component.content.image}}" alt="" loading="lazy">
          </picture>
          <p [innerHTML]="component?.content?.description | trustHtml"></p>
          <button *ngIf="component?.content?.ctaLabel && component?.content?.ctaTarget" class="btn btn-secondary">{{component.content.ctaLabel}}</button>
        </div>
      </ng-container>

      <!-- PDF SECTION -->
      <ng-container *ngIf="component.componentConfig.selector == 'ui-post--pdf-section'">
        <div class="c-inner-post">
          <div class="e-title" *ngIf="component?.content?.title">
            <h2 [innerHTML]="component?.content?.title | trustHtml"></h2>
          </div>
          <p [innerHTML]="component?.content?.description | trustHtml"></p>
          <a *ngIf="component?.content?.ctaLabel && component?.content?.ctaTarget" href="{{component?.content?.ctaTarget}}" target="_blank">
            <button class="btn btn--green">{{component.content.ctaLabel}}</button>
          </a>

        </div>
      </ng-container>

      <ng-container *ngIf="component.componentConfig.selector == 'ui-post--catalog-link'">
        <div class="c-inner-post catalog-link-wrapper">
          <a *ngIf="component?.content?.ctaLabel && component?.content?.ctaTarget && this.catalogLink" href="{{this.catalogLink}}" target="_blank">
            <button class="btn btn--brand-color-03">{{component.content.ctaLabel}}</button>
          </a>
        </div>
      </ng-container>

      <!-- CATALOG LINK -->

    </div>
    <div class="ui-component__children" *ngIf="component.children">
      <ng-container>
        <ng-content></ng-content>
      </ng-container>
    </div>
  </div>
</div>
